/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { propertyStatuses } from '../../utils/property';

const PropertyHeaderCell = ({ value, row }) => {
  const statusCode = _.get(value, 'type_property_status.code', '');
  const name = _.get(value, 'name');
  const activeProperty = _.includes(
    [propertyStatuses.active.code, propertyStatuses.pendingDelete.code],
    statusCode,
  );
  return (
    <div className="rt-td--default">
      {activeProperty ? (
        <Link to={`/property/${row._original.id}`}>{name}</Link>
      ) : (
        <div>{name}</div>
      )}
    </div>
  );
};

PropertyHeaderCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.node]),
  row: PropTypes.shape({
    _original: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
};

export default PropertyHeaderCell;
